<template>
  <div>

    <Modal :mask-closable="false" draggable @on-close="closeDialog" class="demo-drawer-prime"
           title="Change Password" v-model="dialog" width="450">
      <div slot="close"><Icon size="20" class="close-icon" type="md-close" @click="closeDialog"/></div>
      <Form :model="form" :rules="ruleForm" label-position="top" ref="form">
        <Row :gutter="10">
          <Col span="24">
            <FormItem prop="password" label="Password">
              <Input type="password" v-model="form.password"/>
            </FormItem>
          </Col>
          <Col span="24">
            <FormItem prop="passwordConfirmation" label="Password Confirmation">
              <Input type="password" v-model="form.passwordConfirmation"/>
            </FormItem>
          </Col>
        </Row>
      </Form>
      <div slot="footer">
        <Button type="primary" size="large" @click="handleSubmit" :loading="formLoading">SAVE</Button>
        <Button class="cancel-btn" size="large" @click="closeDialog">CANCEL</Button>
      </div>
    </Modal>

  </div>
</template>

<script>
import {generate_UPDATE_ORDER_DATA} from "../../graphql/mutations/orders";
import md5 from 'js-md5';
let form = {password:'', passwordConfirmation:''};
export default {
    name: "ChangePassword",
    props: ['dialog', 'userId'],
    data(){
      return{
        form: {...form},
        ruleForm: {
          password: [{required: true, message: 'Password required', trigger: 'change'},
                     {type: 'string', min: 6, message: 'The password length cannot be less than 6 bits', trigger: 'change'}],
          passwordConfirmation: [{required: true, message: 'Password confirmation required', trigger: 'change'},
                     {type: 'string', min: 6, message: 'The password length cannot be less than 6 bits', trigger: 'change'}],
        },
        formLoading: false
      }
    },
    methods:{
      handleSubmit(){
        this.$refs['form'].validate(valid => {
          if(valid && this.form.password === this.form.passwordConfirmation) this.updatePassword()
          else if(valid) this.$Message.error('Both Password should match!');
        })
      },
      async updatePassword(){
        this.formLoading = true
        let obj = {password: md5(this.form.password), plainPassword: this.form.password}
        await this.updateRecord(this.userId, obj, 'users');
        this.formLoading = false;
        this.$Message.success('Password updated successfully!');
        this.closeDialog()
      },
      async updateRecord(id, obj, table){
        let response = await this.$apollo.mutate({
          mutation: generate_UPDATE_ORDER_DATA(table),
          variables: { id: id, obj: obj}
        })
        if(response.data) return Promise.resolve(response.data);
      },
      closeDialog(){
        this.form = {...form};
        this.$refs['form'].resetFields();
        this.$emit('update:userId', null)
        this.$emit('update:dialog', false)
      }
    }
}
</script>

<style scoped>
.close-icon{
  padding: 4px;
  color: #999
}
</style>
